(() => {
  function init(root) {
    if (!root || root.dataset.ttMobileBuyReady) return;
    const form = root.querySelector('#tt-product-form');
    const original = form?.querySelector('.tt-button--cart');
    const bar = root.querySelector('[data-tt-mobile-buy]');
    const button = bar?.querySelector('[data-tt-mobile-add]');
    const price = root.querySelector('.tt-prices .tt-price');
    const barPrice = bar?.querySelector('[data-tt-mobile-price]');
    if (!original || !bar || !button || !price || !barPrice) return;
    root.dataset.ttMobileBuyReady = 'true';
    const mobile = window.matchMedia('(max-width:749px)');
    document.body.appendChild(bar);
    let pastOriginal = original.getBoundingClientRect().bottom < 0;
    const sync = () => {
      const label = original.textContent.trim();
      const amount = price.textContent.trim();
      const hidden = !mobile.matches || !pastOriginal;
      if (button.disabled !== original.disabled) button.disabled = original.disabled;
      if (button.textContent.trim() !== label) button.textContent = label;
      if (barPrice.textContent.trim() !== amount) barPrice.textContent = amount;
      if (bar.hidden !== hidden) bar.hidden = hidden;
    };
    const syncPosition = () => {
      pastOriginal = original.getBoundingClientRect().bottom < 0;
      sync();
    };
    button.addEventListener('click', () => {
      if (!original.disabled) original.click();
    });
    const observer = new IntersectionObserver(entries => {
      const entry = entries[entries.length - 1];
      pastOriginal = !entry.isIntersecting && entry.boundingClientRect.bottom <= (entry.rootBounds?.top ?? 0);
      sync();
    }, {threshold:0, rootMargin:'0px 0px 100000px 0px'});
    observer.observe(original);
    document.addEventListener('DOMContentLoaded', syncPosition);
    window.addEventListener('load', syncPosition);
    window.addEventListener('resize', syncPosition);
    window.addEventListener('pageshow', syncPosition);
    mobile.addEventListener('change', syncPosition);
    new MutationObserver(sync).observe(original, {attributes:true,attributeFilter:['disabled'],childList:true,subtree:true});
    new MutationObserver(sync).observe(price, {childList:true,subtree:true,characterData:true});
    new ResizeObserver(syncPosition).observe(original);
    syncPosition();
  }
  init(document.getElementById('toptik-ui-product'));
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('#toptik-ui-product')));
})();

